import { createStyles } from '@material-ui/core';

export default createStyles({
    pickerView: {
        marginTop: '8px',
        minWidth: '280px',
        minHeight: '280px',
    },
});
